document.addEventListener('DOMContentLoaded', async () => {
  const privatePropertyNames = (name) => {
    const normalized = name.toLowerCase();

    return (
      normalized === 'custom_id' ||
      normalized === 'additional pricing' ||
      normalized === 'preview' ||
      normalized.startsWith('preview-') ||
      normalized.startsWith('design ') ||
      normalized.startsWith('final design ')
    );
  };

  try {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    for (const item of cart.items) {
      const properties = item.properties || {};

      // Only modify Customify products
      if (!properties._mczr_designId && !properties._custom_id) {
        continue;
      }

      const updatedProperties = {};
      let needsUpdate = false;

      Object.entries(properties).forEach(([key, value]) => {
        if (privatePropertyNames(key) && !key.startsWith('_')) {
          updatedProperties[`_${key}`] = value;
          needsUpdate = true;
        } else {
          updatedProperties[key] = value;
        }
      });

      if (!needsUpdate) {
        continue;
      }

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: item.key,
          quantity: item.quantity,
          properties: updatedProperties
        })
      });
    }
  } catch (error) {
    console.error('Could not privatize Customify properties:', error);
  }
});